import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "footnotemarkerpositioning"
    }}>{`FootnoteMarkerPositioning`}</h1>
    <p>{`Options for positioning footnote reference numbers relative to characters the main text.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NORMAL_MARKER`}</strong>{` = 1181576816`}</p>
      <p parentName="blockquote">{`Uses the position defined in the character style applied to footnote reference numbers. For information, see footnote marker style.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SUPERSCRIPT_MARKER`}</strong>{` = 1181569904`}</p>
      <p parentName="blockquote">{`Superscripts footnote reference numbers.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SUBSCRIPT_MARKER`}</strong>{` = 1181578096`}</p>
      <p parentName="blockquote">{`Subscripts footnote reference numbers.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RUBY_MARKER`}</strong>{` = 1181577840`}</p>
      <p parentName="blockquote">{`Gives the marker ruby style positioning.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      